type QueryParameters = Record<PropertyKey, string | number | boolean | undefined>;

const stringifyQueryParams = (queryParameters: QueryParameters) =>
    Object.keys(queryParameters)
        .reduce<string[]>((acc, key) => {
            const value = queryParameters[key];

            return value ? [...acc, `${key}=${encodeURIComponent(value)}`] : acc;
        }, [])
        .join('&');

export const extendUrlWithQueryParameters = (url: string, queryParameters: QueryParameters): string => {
    const queryString = stringifyQueryParams(queryParameters);

    return queryString ? `${url}?${queryString}` : url;
};
